import { Entity } from '@core/entities/entity'
import { IChecklistTemplateApproval } from './IChecklistTemplateApproval'
import { ChecklistTemplateApprovalData } from './ChecklistTemplateApprovalData'
import { ChecklistTemplateApprovalRule } from './ChecklistTemplateApprovalRule'
import { plainToInstance, Type } from 'class-transformer'

export class ChecklistTemplateApproval extends Entity<IChecklistTemplateApproval> {
  @Type(() => ChecklistTemplateApprovalData)
  data: Array<ChecklistTemplateApprovalData>

  @Type(() => ChecklistTemplateApprovalRule)
  rules?: Array<ChecklistTemplateApprovalRule>

  public getInitialValues(): IChecklistTemplateApproval {
    // questionSet is stored directly as { type, approvalId } — no denormalised `approval`
    // object to flatten (unlike permit), so a plain round-trip is enough.
    return this.toPlain()
  }

  public static new(payload: unknown): ChecklistTemplateApproval {
    const entity = plainToInstance(ChecklistTemplateApproval, payload)
    return entity
  }
}
